export default "__VITE_ASSET__d3c5cc25__"